import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  height: 98%;
  width: ${(props) => (props.isInstructor ? "74%" : "95%")};
  ${STYLES.borderShadow};
  min-width: 240px;
  margin-top: 10px;
  background-color: white;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px 20px;
  overflow: hidden;
  
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  @media only screen and (max-width: 600px) {
    width:  100%;
    /* Styles for screens 600px and larger */
  }
`;
export const PopularCourseContent = styled.div`
  width: 97%;
  min-width: 480px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  flex-wrap: ${(props) => (props.isInstructor ? "wrap" : null)};
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  @media only screen and (max-width: 600px) {
    min-width: 100%;
  }
`;
export const PopularCourse = styled.div`
  box-sizing: border-box;
  width: 22%;
  min-width: 23%;
  padding: 10px 20px;
  margin: 5px;
  background-color: ${Colors.whiteThemeColor};
  border-radius: 10px;
  box-shadow: 1px 3px 3px #6663;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  cursor: pointer;
  @media only screen and (max-width: 900px) {
    width: 47%;
    min-width: 47%;
    padding: 5px;
    margin: 5px;
  }
`;

export const YourCourse = styled.div`
  box-sizing: border-box;
  width: 31%;
  min-width: 120px;
  background-color: ${Colors.whiteThemeColor};
  border-radius: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  @media only screen and (max-width: 900px) {
    width: 49%;
  }
`;
